import React from "react";
import { Animated, StyleSheet } from "react-native";

export const FadeInView = ({ animation, inputRange, opacityOutputRange, transformOutputRange, transform, ...props }) => {
    const animatedViewProps = {
        ...props,
        style: StyleSheet.flatten([
            props.style,
            {
                color: "inherit",
                opacity: animation.interpolate({
                    inputRange: inputRange ?? [0, 1],
                    outputRange: opacityOutputRange ?? ["0", "1"],
                }),
                transform: transform ?? [{
                    translateX: animation.interpolate({
                        inputRange: inputRange ?? [0, 1],
                        outputRange: transformOutputRange ?? ["-10%", "0%"],
                    })
                }]
            }
        ])
    }

    return <Animated.View {...animatedViewProps}></Animated.View>
}